import { createSelector } from 'reselect';

import { selectEntitiesMissions } from '../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { type Selector } from '../../../types/selectors';

import { selectUserMissionsState } from './userMissions';

export const selectRegisteredMissionIds: Selector<Array<number>> = createSelector(
  [selectEntitiesMissions, selectUserMissionsState],
  (missions, userMissions) =>
    Object.keys(missions)
      .map((key) => parseInt(key, 10))
      .filter((missionId) => !missions[missionId]?.optInEnabled || !!userMissions[missionId]?.hasUserRegistered),
);
